import React, { FC } from 'react';
import styled from 'styled-components';
import { SkeletonBlock, SkeletonPageShell, SkeletonStack } from 'src/components/widgets/skeleton';

const OfflineOrderSkeletonShell = styled(SkeletonPageShell).attrs({ $padding: '20px 0' })`
    height: 800px;
`;

const OfflineOrderFrameSkeleton = styled.div`
    height: calc(100% - 54px);
    background: #ffffff;
    padding: 25px;
    min-width: 0;
`;

export const OfflineOrderPageSkeleton: FC = () => (
    <OfflineOrderSkeletonShell aria-hidden='true'>
        <SkeletonBlock $width='min(320px, 100%)' $height='34px' $margin='0 0 20px' />
        <OfflineOrderFrameSkeleton>
            <SkeletonStack $gap='18px'>
                <SkeletonBlock $height='540px' $radius='8px' />
                <SkeletonBlock $width='min(420px, 100%)' $height='13px' />
                <SkeletonBlock $width='min(260px, 100%)' $height='13px' />
            </SkeletonStack>
        </OfflineOrderFrameSkeleton>
    </OfflineOrderSkeletonShell>
);
